<script lang="ts">
    import translate from '../../../../../lib/translate'
    import { BidState, IBid } from '../../../types/Bids'
    import type {ILabel} from '../../../../../types'
    import label from './Bid.translation'
    
    export let bid: IBid
    export let isAgentBid: boolean = true
    
    let ringsizeLabel: ILabel|null = bid.variant.ringsize ? label.variantRingsize(bid.variant.ringsize) : null
    let materialLabel: ILabel|null = bid.variant.material ? label.variantMaterial(bid.variant.material) : null
</script>

{#if bid}
    <li class={bid.state}>
        <div class="bid-image">
            <img loading="lazy" src={bid.product.image.size300} alt="{bid.product.name}">
        </div>
        <div class="bid-details">
            <p class="bid-detail bid-name">
                <span class="value">{bid.product.name}</span>
            </p>
            <p class="bid-detail bid-sku">
                <span class="label">{translate(label.articleNumber)}</span>
                <span class="value">{bid.product.productId}</span>
            </p>
            {#if ringsizeLabel}
                <p class="bid-detail bid-variant">
                    <span class="label">{translate(label.ringsize)}</span>
                    <span class="value">{translate(ringsizeLabel)}</span>
                </p>
            {/if}
            {#if materialLabel}
                <p class="bid-detail bid-variant">
                    <span class="label">{translate(label.material)}</span>
                    <span class="value">{translate(materialLabel)}</span>
                </p>
            {/if}
            {#if bid.bidPrice && isAgentBid}
                <p class="bid-detail bid-price">
                    <span class="label">{translate(label.bidPrice)}</span>
                    <span class="value price-bid">{bid.bidPrice.text}</span>
                </p>
            {/if}
            {#if bid.state === BidState.confirmed && bid.finalPrice}
                <p class="bid-detail final-price">
                    <span class="label">{translate(label.finalPrice)}</span>
                    <span class="value price-final">{bid.finalPrice.text}</span>
                </p>
            {/if}
        </div>
        <div class="bid-state">
            <p class="bid-state-text bid-state-text-{bid.state}">
                {translate(label.bidStatus(bid.state, isAgentBid))}
            </p>
        </div>
    </li>
{/if}